import React, { useState, useEffect } from "react";
import { Button, Modal, Form, FloatingLabel } from "react-bootstrap";
import { toast } from "react-hot-toast";

export default function EditHistory({ data, getData, dataService }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [validated, setValidated] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    count: 0,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id || "",
        count: data.count || 0,
      });
    }
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);

    if (form.checkValidity() === false) {
      event.stopPropagation();
      return;
    }

    setIsSaving(true);
    try {
      const loadingMessage = toast.loading("Updating...");

      const response = await dataService.updateSearchHistory(formData);

      if (response.data.success === true) {
        getData();
        toast.success(response.data.message, { id: loadingMessage });
        setValidated(false);
        setShow(false);
        setIsSaving(false);
      } else {
        toast.error(
          response.data.message || "Failed to update search history",
          {
            id: loadingMessage,
          }
        );
        setIsSaving(false);
      }
    } catch (error) {
      console.log(error);
      setIsSaving(false);
      toast.error("An error occurred while updating search history");
    }
  };

  return (
    <>
      <Button variant="outline-primary" size="sm" onClick={handleShow}>
        <i className="bi bi-pencil"></i>
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        scrollable={true}
        className="mt-5"
        size="lg"
      >
        <Modal.Header closeButton={!isSaving}>
          <Modal.Title>Edit Search History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            className="px-3"
          >
            <FloatingLabel controlId="floatingInput" label="Count">
              <Form.Control
                type="number"
                placeholder="Enter count"
                name="count"
                min="0"
                value={formData.count}
                onChange={handleInputChange}
              />
            </FloatingLabel>

            <Modal.Footer className="mt-4">
              <Button
                variant="secondary"
                onClick={handleClose}
                disabled={isSaving}
              >
                Close
              </Button>
              <Button type="submit" variant="success" disabled={isSaving}>
                {isSaving ? "Updating..." : "Update"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
